import styled from 'styled-components'

const Li = styled.li`
  h2 {
    display: inline;
  }

  p {
    font-weight: ${props => props.theme.font.weight.bold};
  }
`

const PriceAsterisk = styled.span`
  font-size: ${props => props.theme.font.size['display-1']};
  font-weight: ${props => props.theme.font.weight.regular};
`

const PriceSave = styled.span`
  color: ${props => props.theme.color.palette.red};
  white-space: nowrap;
`

const PriceWas = styled.span`
  color: ${props => props.theme.color.monochrome.dark};
  text-decoration: line-through;

  ${props =>
    !(props.isPayPalAvailable && props.ShowPaypalCreditOption) &&
    `
      border-left: 1px solid ${props.theme.color.monochrome.dark};
      padding-left: 5px;
      margin-left: 5px;
    `}
`

const OfferPriceTitle = styled.h2`
  color: ${props => props.theme.color.palette.red};
`

export { Li, PriceAsterisk, PriceSave, PriceWas, OfferPriceTitle }
